// Canonical discipline → color map.
// Source: anArtizen palette · "One mark, seven crafts" + two extensions.
// Each entry has both a hex (for inline styles / SVG / canvas) and an HSL
// (for tailwind text/bg classes via arbitrary value).
export const DISCIPLINES = [
  { key: "music",      label: "Music",       hex: "#2A8E96", note: "Teal" },
  { key: "dance",      label: "Dance",       hex: "#7FB5A8", note: "Sage" },
  { key: "comedy",     label: "Comedy",      hex: "#F2A776", note: "Orange" },
  { key: "visual_art", label: "Visual Art",  hex: "#236B8E", note: "Blue" },
  { key: "film",       label: "Film",        hex: "#E66B66", note: "Coral" },
  { key: "theatre",    label: "Theatre",     hex: "#E66B66", note: "Coral (shared with Film)" },
  { key: "writing",    label: "Writing",     hex: "#F4DDB8", note: "Sand" },
  { key: "design",     label: "Design",      hex: "#D4A23B", note: "Mustard (new)" },
  { key: "fashion",    label: "Fashion",     hex: "#A87CAF", note: "Plum (new)" },
];

export const DISCIPLINE_COLOR = DISCIPLINES.reduce((acc, d) => { acc[d.key] = d.hex; return acc; }, {});
export const DISCIPLINE_LABEL = DISCIPLINES.reduce((acc, d) => { acc[d.key] = d.label; return acc; }, {});
export const DISCIPLINE_KEYS = DISCIPLINES.map((d) => d.key);

export function disciplineColor(key) {
  return DISCIPLINE_COLOR[(key || "").toLowerCase()] || "#9CA3AF"; // neutral fallback
}

export function disciplineLabel(key) {
  return DISCIPLINE_LABEL[(key || "").toLowerCase()] || (key || "").replace("_", " ");
}

/** A pill / chip rendering a discipline with its canonical color. */
import React from "react";
export function DisciplineChip({ k, size = "sm", filled = false, className = "" }) {
  const color = disciplineColor(k);
  const label = disciplineLabel(k);
  const baseSize = size === "lg" ? "text-xs px-3 py-1.5" : "text-[10px] px-2 py-1";
  if (filled) {
    return (
      <span
        className={`inline-block font-mono uppercase tracking-[0.18em] ${baseSize} ${className}`}
        style={{ background: color, color: needsLightText(color) ? "#0a0a0a" : "#ffffff" }}
      >
        {label}
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center gap-1.5 font-mono uppercase tracking-[0.18em] ${baseSize} ${className}`}
      style={{ color }}
    >
      <span style={{ width: 6, height: 6, background: color, display: "inline-block" }} />
      {label}
    </span>
  );
}

// Light backgrounds (Sand, Sage) need dark text for legibility.
function needsLightText(hex) {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  // Perceived luminance — anything above ~165 reads as light.
  return (0.299 * r + 0.587 * g + 0.114 * b) > 165;
}
